var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11490_7357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6 13.45H10.7V12.43H11.6C12.05 12.43 12.45 12.14 12.58 11.7L14.86 4.09C14.94 3.83 14.91 3.55 14.78 3.3C14.65 3.05 14.43 2.88 14.16 2.81L7.89 1.09C7.37 0.939996 6.82 1.23 6.65 1.75L6.09 3.43L5.12 3.11L5.68 1.43C6.02 0.389996 7.11 -0.180004 8.16 0.109996L14.43 1.85C14.96 2 15.4 2.35 15.67 2.83C15.94 3.31 16 3.87 15.84 4.4L13.56 12C13.3 12.87 12.52 13.45 11.61 13.45H11.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17 16H2.04C0.92 16 0 15.09 0 13.96V4.79C0 3.67 0.91 2.75 2.04 2.75H9.17C10.29 2.75 11.21 3.66 11.21 4.79V13.96C11.21 15.08 10.3 16 9.17 16ZM2.04 3.77C1.48 3.77 1.02 4.23 1.02 4.79V13.96C1.02 14.52 1.48 14.98 2.04 14.98H9.17C9.73 14.98 10.19 14.52 10.19 13.96V4.79C10.19 4.23 9.73 3.77 9.17 3.77H2.04Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11490_7357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplay);
export default __webpack_public_path__ + "static/media/display.0596db5a67169093b0e19472b8cbf211.svg";
export { ForwardRef as ReactComponent };